import { render, staticRenderFns } from "./helpSider.vue?vue&type=template&id=36bf04e0&scoped=true"
import script from "./helpSider.vue?vue&type=script&lang=js"
export * from "./helpSider.vue?vue&type=script&lang=js"
import style0 from "./helpSider.vue?vue&type=style&index=0&id=36bf04e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf04e0",
  null
  
)

export default component.exports